import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import * as ReportLocationsActions from 'web-app/react/entities/report-locations/actions';

import * as Actions from './actions';

export class ReportAccidentIncidentModalState extends Record<{
    readonly isVisible: boolean;
    readonly loading: boolean;
    readonly isSubmitting: boolean;
    readonly loadingChildren: boolean;
    readonly loadingLocations: boolean;
    readonly institutionId?: string;
    readonly childId?: string;
    readonly reportId?: string;
    readonly isEdit: boolean;
    readonly initialStep: 'first' | 'last';
}>({
    isVisible: false,
    loading: false,
    isSubmitting: false,
    loadingChildren: false,
    loadingLocations: false,
    institutionId: undefined,
    childId: undefined,
    reportId: undefined,
    isEdit: false,
    initialStep: 'first',
}) {}

export default makeReducer<ReportAccidentIncidentModalState>(
    [
        match(Actions.showNew, (state, {payload}) => {
            return state.merge({
                isVisible: true,
                loadingLocations: true,
                childId: payload.childId,
                institutionId: payload.institutionId,
                isEdit: false,
            });
        }),
        match(Actions.showExisting, (state, {payload}) => {
            return state.merge({
                isVisible: true,
                loadingLocations: true,
                reportId: payload.reportId,
                institutionId: payload.institutionId,
                isEdit: true,
                initialStep: 'last',
            });
        }),
        match(ReportLocationsActions.fetchLocationsSuccess, state => {
            return state.merge({
                loadingLocations: false,
            });
        }),
        match(ReportLocationsActions.fetchLocationsFailed, state => {
            return state.merge({
                loadingLocations: false,
            });
        }),
        match(Actions.fetchChildren, state => {
            return state.merge({
                loadingChildren: true,
            });
        }),
        match(Actions.fetchChildrenSuccess, state => {
            return state.merge({
                loadingChildren: false,
            });
        }),
        match(Actions.fetchChildrenFailed, state => {
            return state.merge({
                loadingChildren: false,
            });
        }),
        match(Actions.hide, () => {
            return new ReportAccidentIncidentModalState();
        }),
    ],
    new ReportAccidentIncidentModalState(),
);
